import React, { useState } from "react";
import "./TimelineWindowContent.css";

export default function TimelineWindowContent({ timelineData, onOpenProjectWindow }) {
  const [expandedCareerId, setExpandedCareerId] = useState("");

  return (
    <>
      {timelineData.map((item) => {
        const key = item.id || item.phase;
        const hasDetails = item.eventType === "career" && Array.isArray(item.details) && item.details.length > 0;
        const isProjectItem = item.eventType === "project" && Boolean(item.projectId);
        const isInteractive = hasDetails || isProjectItem;
        const isExpanded = hasDetails && expandedCareerId === key;

        const handleItemAction = () => {
          if (isProjectItem) {
            onOpenProjectWindow?.(item.projectId);
            return;
          }

          if (!hasDetails) {
            return;
          }

          setExpandedCareerId((current) => (current === key ? "" : key));
        };

        return (
          <div
            key={key}
            className={`windowTimelineItem ${item.eventType === "project" ? "projectTimelineItem" : ""} ${
              isExpanded ? "expandedTimelineItem" : ""
            }`.trim()}
            onClick={isInteractive ? handleItemAction : undefined}
            onKeyDown={(event) => {
              if ((event.key === "Enter" || event.key === " ") && isInteractive) {
                event.preventDefault();
                handleItemAction();
              }
            }}
            role={isInteractive ? "button" : undefined}
            tabIndex={isInteractive ? 0 : undefined}
            aria-expanded={hasDetails ? isExpanded : undefined}
          >
            <p>{item.phase}</p>
            <h3>{item.title}</h3>
            <span>{item.description}</span>

            {hasDetails && isExpanded && (
              <div className="windowTimelineDetailPanel">
                <ul>
                  {item.details.map((detail, index) => (
                    <li key={`${key}-detail-${index}`}>{detail}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        );
      })}
    </>
  );
}
